<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Enviar SMS</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row justify="center">
                                <v-col cols="12" md="6">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Teléfono:</v-list-item-title>
                                            <vue-tel-input-vuetify v-model="tel" id="telprueba"
                                                                   outlined label=""
                                                                   autocomplete="off"
                                                                   validCharactersOnly="false"
                                                                   maxlength="13"
                                                                   placeholder=""
                                                                   @input="onInput"
                                                                   @validate="ValidationMethod"
                                                                   dense>
                                                <template v-slot:append-outer>
                                                    <v-btn style="top: -8px"
                                                           :disabled="disabled"
                                                           @click="Agregar()">Agregar</v-btn>
                                                </template>
                                            </vue-tel-input-vuetify>
                                            <span v-if="validaTelefono" class='spanError' style="color:red;font-size:11px">
                                                Teléfono inválido
                                            </span>
                                            <div v-for="(item, i) in telefonos">
                                                <v-chip close
                                                        @click:close="telefonos.splice(i, 1)">
                                                    {{ item.text }}
                                                </v-chip>
                                            </div>
                                            <span v-if="validaTelefonos" class='spanError' style="color:red;font-size:11px">
                                                Tiene que agregar número telefónico
                                            </span>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Mensaje:</v-list-item-title>
                                            <v-textarea v-model="sms"
                                                        counter="160"
                                                        maxlenght="160"
                                                        autocomplete="off"
                                                        required
                                                        :rules="[rules.required, rules.text, rules.counter]"
                                                        outlined
                                                        dense
                                                        v-on:blur="sms = sms != null ? sms.trim() : null"
                                                        @keypress="filtertext($event)"
                                                        name="input-7-4"></v-textarea>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn class="ma-2"
                                           @click="Guardar()"
                                           color="primary">
                                        Enviar
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>

                                    <v-btn class="ma-2" @click="$router.push({ name: 'Sistemas' }).catch((error) => error);" color="error">
                                        Cancelar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import Sistemas from "@/services/Sistemas/sistemas.service.js";
    import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
        },
        data() {
            return {
                tel: '',
                phone: {
                    number: '',
                    valid: false,
                    country: ''
                },
                valid: true,
                showcargando: true,
                sms: '',
                telefonos: [
                ],
                rules: {
                    required: value => !!value || 'Campo requerido',
                    counter: value => {
                        if (value == null || value == '') {
                            return true
                        }
                        else {
                            return value.length >= 5 || 'Mínimo 5 caracteres'
                        }
                    },
                    text: value => {
                        if (value == null || value == '') {
                            return true
                        }
                        else {
                            return value.length <= 160 || 'Máximo 160 caracteres'
                        }
                    },
                },
                validaTelefono: false,
                validaTelefonos: false,
                disabled: false,
            }

        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            ValidationMethod(object) {
                if (!object.isValid) {
                    this.disabled = true;
                }
                else
                    this.disabled = false;
            },
            Agregar() {
                if (this.tel != '') {
                    let indice = this.telefonos.findIndex((obj => obj.text === this.phone.number));
                    if (indice == -1) {
                        this.telefonos.push({
                            text: this.phone.number
                        });
                    }
                    this.tel = '';
                    this.validaTelefono = false;
                    this.validaTelefonos = false;
                }
                else {
                    this.$swal(
                        "Atención",
                        "Tiene que agregar un número de teléfono",
                        "info"
                    );
                }
            },
            async Guardar() {
                let numeros = '';
                if (this.telefonos.length == 0)
                    this.validaTelefonos = true;
                if (this.$refs.form.validate() && this.telefonos.length > 0) {
                    for (var i = 0; i < this.telefonos.length; i++) {
                        if (i == this.telefonos.length - 1) {
                            numeros += this.telefonos[i].text;
                        }
                        else
                            numeros += this.telefonos[i].text + ',';
                    }
                    let formdata = new FormData();
                    formdata.append("telefonos", numeros);
                    formdata.append("mensaje", this.sms);

                    this.$swal({
                        position: "center",
                        title: "Procesando el envio del mensaje...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirm: false,
                    });
                    this.$swal.showLoading();
                    await Sistemas.EnviarMensaje(formdata).then(data => {
                        if (data.error == false) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                html: "SMS enviado con éxito",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {
                                this.$refs.form.reset();
                                this.telefonos = [];

                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                text: data.msg + ", O verifiqué los números de teléfono",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {

                            });
                        }
                    });
                }
            },
            required(value) {
                if (value instanceof Array && value.length == 0) {
                    return 'Campo requerido.';
                }
                return !!value || 'Campo requerido.';
            },
            onInput(formattedNumber, { number, valid, country }) {
                if (formattedNumber != '') {
                    this.validaTelefono = false;
                    this.telefonoFormat = formattedNumber;


                    if (number.input == number.national) {
                        this.phone.number = number.e164;
                        this.phone.valid = valid;
                        this.phone.country = country && country.name;
                    }
                    else {
                        this.validaTelefono = true;
                        this.phone.number = number.e164;
                        this.phone.valid = false;
                        this.phone.country = country && country.name;
                    }
                }
                else {
                    this.validaTelefono = false;
                }
            },
            filter: function (evt) {
                if (!/^[+]?[0-9]*$/.test(evt)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            filtertext: function (evt) {

                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();
                if (!/^[ a-zA-Z0-9,]+$/.test(expect)) {
                    evt.preventDefault();
                }
                else {
                    return true;
                }
            }
        },
        watch: {
            telefonos(val, prev) {
                if (val.length === prev.length) return

                this.telefonos = val.map(v => {
                    if (typeof v === 'string') {
                        v = {
                            text: v,
                        }
                        this.nonce++
                    }
                    return v
                })
            }
        },
        mounted() {
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>